// src/pages/PatientsOverview/PatientsThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { createInsurance, createPatient } from "../../apiservice/setting"; // adapt path if needed
import {
  getPatientInsuranceDetails,
  deletePatientEntry,
  getInsuranceDetails,
  deleteInsuranceEntry,
} from "../../apiservice/pharma"; // adapt path if needed

// Fetch insurance companies list
export const fetchInsuranceList = createAsyncThunk(
  "patients/fetchInsuranceList",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getInsuranceDetails(null);
      // expect res.data.data
      return res.data || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Fetch patients list
export const fetchPatientList = createAsyncThunk(
  "patients/fetchPatientList",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getPatientInsuranceDetails(null);
      return res.data || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// create or update insurance company
export const createOrUpdateInsurance = createAsyncThunk(
  "patients/createOrUpdateInsurance",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await createInsurance(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// create or update patient
export const createOrUpdatePatient = createAsyncThunk(
  "patients/createOrUpdatePatient",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await createPatient(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// delete insurance
export const removeInsurance = createAsyncThunk(
  "patients/removeInsurance",
  async (payloadId, { rejectWithValue }) => {
    try {
      const res = await deleteInsuranceEntry({ id: payloadId });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// delete patient
export const removePatient = createAsyncThunk(
  "patients/removePatient",
  async (payloadId, { rejectWithValue }) => {
    try {
      const res = await deletePatientEntry({ id: payloadId });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Optional: a small thunk to fetch simplified insurance names for autocomplete/lookup
export const fetchInsuranceCompaniesLookup = createAsyncThunk(
  "patients/fetchInsuranceCompaniesLookup",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getInsuranceDetails({ query: "" });
      // map to { value, label }
      const items = (res.data?.data || []).map((it) => ({
        value: it.insurance_company_id,
        label: it.company_name,
      }));
      return items;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
